<template>
  <div v-if="visibleAlerts.length > 0" class="mb-3">
    <div
      v-for="alert in visibleAlerts"
      :key="alert.key"
      :class="['alert alert-dismissible d-flex align-items-center mb-2 py-2 px-3', alertClass(alert.level)]"
      style="border:1px solid #e9ecef;border-radius:10px;font-size:.85rem;"
    >
      <i :class="['bi mr-2', alert.icon]" style="font-size:1rem;flex-shrink:0;"></i>
      <div class="flex-grow-1">
        <strong>{{ alert.title }}:</strong> {{ alert.message }}
      </div>
      <button type="button" class="close ml-2 p-0" style="font-size:1.2rem;line-height:1;" @click="dismiss(alert.key)">
        <span>&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminAlertsBanner',

  data() {
    return {
      alerts: [],
      dismissed: [],
    };
  },

  computed: {
    visibleAlerts() {
      return this.alerts.filter(a => !this.dismissed.includes(a.key));
    },
  },

  mounted() {
    this.fetchAlerts();
    // Re-check every 5 minutes
    this._interval = setInterval(this.fetchAlerts, 300000);
  },

  beforeDestroy() {
    clearInterval(this._interval);
  },

  methods: {
    async fetchAlerts() {
      try {
        const { data } = await axios.get('/api/admin/alerts');
        // Re-surface any alert that's now resolved (key no longer in response)
        const newKeys = data.map(a => a.key);
        this.dismissed = this.dismissed.filter(k => newKeys.includes(k));
        this.alerts = data;
      } catch (e) { /* silent */ }
    },

    dismiss(key) {
      this.dismissed.push(key);
    },

    alertClass(level) {
      return {
        danger:  'alert-danger',
        warning: 'alert-secondary',
        info:    'alert-secondary',
        success: 'alert-primary',
      }[level] || 'alert-secondary';
    },
  },
};
</script>
